export default __webpack_public_path__ + "static/media/Astro_Jupiter_Black.1bc2de5c.png";